export default __webpack_public_path__ + "static/media/convert-reward-to-ecredit-step3.39410b8b.png";